<template>
  <!-- 地址弹框列表组件 -->
  <div>
    <el-dialog
      class="addressDialog"
      title="地址管理中心"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="1000px"
    >
      <div id="AddListDialog">
        <div class="addressWrap">
          <div class="iconWrap">
            <i class="el-icon-arrow-left" @click="leftAddress"></i>
          </div>
          <div class="list">
            <div
              v-for="(item,index) of detailList.slice(startIndex, endIndex)"
              :key="index"
              class="items"
              :class="chooseId==item.id?'chooseItem':''"
              @click="changChooseId(item)"
            >
              <div class="topWrap">
                <div class="firstRow">
                  <span class="name"> {{ item.name }}</span>
                  <span class="phone">{{ item.tel | isPoneMatch }}</span>
                </div>
                <div class="twoRow">
                  <span class="leftName">收货地址：</span>
                  <span class="addressInfo">{{ item.address }}</span>
                </div>
              </div>
              <div class="threeRow">
                <span v-if="item.isDefault" class="isDefalut">默认地址</span>
                <span v-if="!item.isDefault" @click.stop="changDefault(item)">设为默认</span>
                <!-- <span @click.stop="modifyAdd(item.id)">编辑</span> -->
                <span v-if="!item.isDefault" @click.stop="deleteAddress(item.id)">删除</span>
              </div>
            </div>
            <div class="items lastItem" @click="addAddress">
              <img src="@/assets/images/addIcon.png" class="addBtn">
              <div class="names">使用新地址</div>
            </div>
          </div>
          <div class="iconWrap">
            <i class="el-icon-arrow-right" @click="rightAddress"></i>
          </div>
        </div>
      </div>
    </el-dialog>
    <addressPop ref="addressDia" @complate="complateAddress" />
  </div>
</template>
<script>
/*global BaseApi */
import addressPop from './addressPop.vue'
export default {
  name: 'AddListDialog',
  components: {
    addressPop
  },
  props: {
    chooseAddId: {
      require: false,
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      dialogVisible: false,
      isShowNoData: false,
      isAddressLoading: true,
      threeList: [],
      detailList: [],
      chooseId: null,
      startIndex: 0,
      endIndex: 3,
      paramInfo: {}
    }
  },
  watch: {
    chooseAddId(val) {
      this.chooseId = val
    }
  },
  methods: {
    openDialog(obj) {
      this.paramInfo = obj
      this.chooseId = obj.id
      this.queryFirmAddress()
      this.dialogVisible = true
    },
    // 获取收货地址
    queryFirmAddress() {
      var that = this
      this.detailList = []
      BaseApi.getUserAddress({}).then((response) => {
        // eslint-disable-next-line no-unused-vars
        const { value, message, code } = response.data
        that.isAddressLoading = false
        if (Number(code) === 0) {
          if (value.length !== 0) {
            for (let i = 0; i < value.length; i++) {
              const item = value[i]
              item.name = item.recipients
              item.tel = item.recipientsCellphone
              item.isDefault = item.defaultFlag
              item.address = item.addressName
              item.id = item.addressId
              that.detailList.push(item)
              // 进入地址是选择的是第二页的判断
              if (item.id == that.chooseId) {
                that.startIndex = Math.floor(i / 3) * 3
                that.endIndex = Math.floor(that.startIndex + 3)
              }
              if (item.defaultFlag) {
                sessionStorage.setItem('defaultAddress', JSON.stringify(item))
              }
            }
          } else {
            that.isShowNoData = true
          }
        } else {
          // eslint-disable-next-line no-undef
          this.$message(message)
        }
      })
    },
    addAddress() {
      const params = {
        isAdd: 'add'
      }
      this.$refs.addressDia.openDialog(params)
    },
    complateAddress() {
      this.queryFirmAddress()
    },
    changChooseId(obj) {
      this.chooseId = obj.id
      this.$emit('changAddId', obj)
      this.dialogVisible = false
    },
    modifyAdd(id) {
      const params = {
        isAdd: 'modify',
        modifyId: id
      }
      this.$refs.addressDia.openDialog(params)
    },
    changDefault(item) {
      // 改变是否默认地址
      // if (item.isDefault === true) {
      const sendValue = {
        'addressId': item.id,
        'addressName': item.address, // 收货地址
        'defaultFlag': 1, // 是否设置为默认收获地址 (0:否 1:是)
        'postCode': item.postCode, // 邮政编码
        'recipients': item.name, // 收货人
        'recipientsCellphone': item.tel, //	收货人电话
        'region': item.region // 地区(前端维护辅助字段)
      }
      const that = this
      BaseApi.updateUserAddress(sendValue).then(response => {
        const { code, message } = response.data
        this.$message(message)
        if (code === 0 || code === '0') {
          that.detailList.forEach((ele) => {
            // eslint-disable-next-line eqeqeq
            if (ele.addressId == item.addressId) {
              ele.isDefault = 1
              sessionStorage.setItem('defaultAddress', JSON.stringify(ele))
            } else {
              ele.isDefault = 0
            }
          })
        }
      })
      // } else {
      //   item.isDefault = 1
      //   this.$message('必须有一个默认地址')
      // }
    },
    deleteAddress(id) {
      const that = this
      const addressId = {
        addressId: id
      }
      BaseApi.deleteUserAddress(addressId).then(response => {
        const { code, message } = response.data
        // eslint-disable-next-line eqeqeq
        if (code == 0) {
          this.detailList = []
          that.queryFirmAddress()
        } else {
          this.$message(message)
        }
      })
    },
    leftAddress() {
      if (this.startIndex == 0) {
        this.$message('已经是第一页了')
      } else {
        this.startIndex = this.startIndex - 3 > 0 ? this.startIndex - 3 : 0
        this.endIndex = this.endIndex - 3
      }
    },
    rightAddress() {
      if (this.endIndex >= this.detailList.length + 1) {
        this.$message('已经是最后一页了')
      } else {
        this.startIndex = this.endIndex
        this.endIndex = this.endIndex + 3
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.addressDialog{
  /deep/.el-dialog{
    background: #ffffff !important;
    border-radius: 8px 8px 8px 8px;
  }
  /deep/.el-dialog__header{
    padding:13px 20px 20px;
    border-bottom: 1px solid #dddddd;
    .el-dialog__title{
      font-size: 18px;
      font-family: PingFang HK-Medium, PingFang HK;
      font-weight: 500;
      color: #333333 !important;
      line-height: 21px;
    }
    .el-dialog__close{
      color:#98999D;
    }
  }
  /deep/.el-dialog__body{
    padding:20px 0;
  }
}
#AddListDialog{
  // .header{
  //   display: flex;
  //   justify-content: space-between;
  //   align-items: center;
  //   background: #424556;
  //   height: 70px;
  //   padding:0 40px;
  //   box-sizing: border-box;
  //   .title{
  //     font-size: 22px;
  //     font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
  //     font-weight: 500;
  //     color: #FFFFFF;
  //   }
  //   .addBtn{
  //     cursor: pointer;
  //     font-size: 22px;
  //     font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
  //     font-weight: 500;
  //     color: #E4CA91;
  //   }
  // }
  .addressWrap{
    display: flex;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
    .iconWrap{
      cursor: pointer;
      /deep/.el-icon-arrow-left,/deep/.el-icon-arrow-right{
        font-size: 26px;
        color: #D9D9D9;
        font-weight: bold;
        cursor: pointer;
      }
    }
    .list{
      display: flex;
      width: 1130px;
      margin: 0 5px;
      overflow: hidden;
      .items{
        margin-right:11px;
        width: 32.5%;
        height: 176px;
        border-radius: 4px 4px 4px 4px;
        border: 3px solid #D9D9D9;
        padding:10px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: center;
        cursor: pointer;
      }
      .chooseItem{
        border: 3px solid #EB6643;
        background: #ffffff;
      }
      .lastItem{
        text-align: center;
        img{
          width: 30px;
          height: 30px;
          margin: 14px auto 14px;
        }
        .names{
          font-size: 18px;
          font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
          font-weight: 400;
          color: #333333;
        }
      }
      .topWrap{
        .firstRow{
          position: relative;
          .name{
            font-size: 20px;
            font-family: Alibaba PuHuiTi-Bold, Alibaba PuHuiTi;
            font-weight: bold;
            color: #333333;
            line-height: 23px;
          }
          .phone{
            margin-left:20px;
            display: inline-block;
            font-size: 22px;
            font-family: ITC Avant Garde Gothic Pro-Demi, ITC Avant Garde Gothic Pro;
            font-weight: normal;
            color: #333333;
            line-height: 26px;
          }
          .choosImg{
            position: absolute;
            right:-10px;
            top:-10px;
            width: 40px;
            height: 40px;
          }
        }
        .twoRow{
          margin-top:10px;
          font-size: 18px;
          font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
          font-weight: 400;
          color: #999999;
          line-height: 21px;
          display: flex;
          .leftName{
            width:110px;
            white-space: nowrap;
          }
          .addressInfo{
            width: 245px;
            height: 86px;
            color: #999999;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            line-clamp: 4;
            -webkit-box-orient: vertical;
          }
        }
      }
      .threeRow{
        text-align: right;
        font-size: 18px;
        font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
        font-weight: 400;
        color: #999999;
        line-height: 21px;
        position: relative;
        .isDefalut{
          position: absolute;
          bottom:0;
          left: -10px;
          width: 81px;
          height: 24px;
          background: #EB6643;
          border-radius: 0px 14px 14px 0;
          text-align: center;
          line-height: 24px;
          font-size: 16px;
          font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
          font-weight: 500;
          color: #ffffff;
        }
        span{
          display: inline-block;
          padding: 0 10px;
          position: relative;
          cursor: pointer;
        }
        span::after{
          content:'';
          position: absolute;
          right:0;
          top:4px;
          width:1px;
          height: 14px;
          background: #6F7181;
        }
        span:last-child::after{
          display: none;
        }
      }
    }
  }
}
</style>

